// @flow

import React from 'react'
import ReactImageCrop from 'react-image-crop'

import { ImageAsBlob } from '../../ImageAsBlob'
import type { Crop } from '../../ImageAsBlob'

import PageOverlay from '../../Controls/PageOverlay'
import OpinaryInput from '../../Controls/OpinaryInput'
import ColorButton from '../../Controls/ColorButton'

type File = {
  preview?: string,
}

type Props = {
  file: File,
  crop?: Crop,
  poll: Object,
  blob: ?string,
  setBlob: Function,
  onClose: Function,
  optionIndex: number,
  onComplete: Function,
  uploadImage: Function,
  onImageLoaded: Function,
  fileForOptionId: ?string,
  changePhotoCredit: Function,
}

const CropModal = ({
  changePhotoCredit,
  optionIndex,
  file,
  fileForOptionId,
  crop,
  blob,
  onImageLoaded,
  onComplete,
  setBlob,
  onClose,
  uploadImage,
  poll,
}: Props) => {
  return (
    <PageOverlay>
      <div className="bg-white gray w-100 h-100 flex flex-column">
        <div className="h3 bg-op-con-dark f6 ph4 white flex items-center">
          Upload Image
        </div>
        <OpinaryInput
          placeholder="Photo Credit"
          className="mb4 mh4 mt4"
          onChange={changePhotoCredit}
        ></OpinaryInput>
        <div className="flex-auto flex ph4 mb4">
          <div className="mr4 mw-50 overflow-y-auto">
            <div className="mb2">Adjust cropping area</div>
            <ReactImageCrop
              src={file.preview}
              crop={crop}
              keepSelection={true}
              onImageLoaded={crop => onImageLoaded(crop)}
              onComplete={onComplete}
            />
          </div>
          <div className="h-100 nowrap">
            <div className="mb2">Preview</div>
            <div className="flex">
              <div className="dib mr4 f6 flex flex-column">
                <div>
                  {crop ? (
                    <ImageAsBlob
                      display={true}
                      width={150}
                      height={poll.horizontal ? 100 : 190}
                      src={file.preview}
                      crop={crop}
                      onData={setBlob}
                    />
                  ) : null}
                </div>
                <div className="mt-auto">
                  This image shows as an option of your poll
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 h3 bg-near-white flex flex-none items-center justify-center">
          <div className="w-90 tr">
            <ColorButton
              onClick={onClose}
              className="mr2"
              colorClass="gray"
              borderClass="b--gray"
            >
              Close
            </ColorButton>
            <ColorButton
              disabled={!blob}
              colorClass="op-con-dark"
              borderClass="b--op-con-dark"
              onClick={() => {
                if (!blob) return // thanks flow for forcing me to write this
                onClose()
                uploadImage(blob)
              }}
            >
              Upload
            </ColorButton>
          </div>
        </div>
      </div>
    </PageOverlay>
  )
}

export default CropModal



// WEBPACK FOOTER //
// ./src/components/PollForm/RankingPollForm/CropModal.js